import { Navigate, Outlet } from "react-router-dom";

import { useAuthStore } from "src/store/authStore";

export default function PublicLayout() {
  const { authToken } = useAuthStore();

  // ✅ Single check protects ALL routes in this group
  if (authToken) {
    return <Navigate to="/dashboards" replace />;
  }

  return (
    <>
      <div className="d-flex flex-fill flex-column">
        <Outlet />
      </div>
    </>
  );
}
